import { CreateInvoice } from "../../billing/timesheets/ServiceInvoice";
import { tariffs } from "../../billing/timesheets/BillingTariff";

// const laaAssessmentMeetingCode = 'QUIQR';

const adminCharge = {
    "description": "Administration Charge",
    "key": "ADMIN01",
    "category": "services",
    "quantity": 1,
    "code": "adminCharge",
    "measure": "hour",
    "amount": 40,
    "rate": 40,
    "section": "assessment"
};

const buildInvoiceData = ({ digest, invoiceType, reference }) => {
    const data = { ...digest };
    const { timesheet } = digest;

    // post new contract go live we have to bill at the new rates regardless of what was originally quoted
    // const oldContractRulesApply = (digest.submittedAt && digest.submittedAt < new Date('2025-12-20').valueOf());
    // const tariff = oldContractRulesApply ?
    //     timesheet.tariff : tariffs.get(timesheet.tariff.code);

    const tariff = tariffs.get(timesheet.tariff.code);

    // if (!oldContractRulesApply && timesheet.tariff.code === 'defendant') {
    //     const assessment = timesheet.items.find(({ key }) => key === laaAssessmentMeetingCode);
    //     const charge = timesheet.items.find(({ key }) => key === adminCharge.key);

    //     // console.log('buildInvoiceData', oldContractRulesApply, assessment, charge, timesheet.items)

    //     if (assessment?.quantity > 0) {
    //         // add the admin charge if the meeting took place and it hasn't already been added
    //         if (!charge) {
    //             timesheet.items.push(adminCharge);
    //         }
    //     }
    //     else {
    //         // the admin charge should be removed if the assessment meeting didn't take place
    //         timesheet.items = timesheet.items.filter(({ key }) => key !== adminCharge.key);
    //     }
    // }

    timesheet.items = timesheet.items.filter(({ key }) => key !== adminCharge.key);
    
    const vatRate = invoiceType === 'purchase' && !data.intermediary.profile.vatNumber ? 0.0 : timesheet.tariff.taxRate;

    data.quote = CreateInvoice(
        {
            tariff: { ...tariff, taxRate: vatRate },
            items: timesheet.items,
            reference,
            invoiceType
        }
    )

    return data;
}

export {
    buildInvoiceData
}